import * as React from "react";
import type { SVGProps } from "react";
const SvgAlmaOnCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#fa5022"
      d="M20 6H4c-1.105 0-2 .908-2 2.028v8.944C2 18.092 2.895 19 4 19h16c1.105 0 2-.908 2-2.028V8.028C22 6.908 21.105 6 20 6"
    />
    <path
      fill="#fff"
      d="M18.196 13.773c-.496 0-.892-.418-.892-.934 0-.517.403-.934.892-.934.495 0 .891.417.891.934.007.516-.396.934-.892.934m.898-2.64v.474a1.3 1.3 0 0 0-.488-.41 1.35 1.35 0 0 0-.623-.149c-.884 0-1.57.8-1.57 1.79 0 .991.686 1.791 1.57 1.791a1.38 1.38 0 0 0 1.168-.637v.552H20v-3.41zm-10.339-.948h.906v4.36h-.906zm1.94 2.427c0-.934.566-1.564 1.358-1.564.488 0 .878.22 1.111.595.234-.375.623-.595 1.111-.595.793 0 1.359.63 1.359 1.564v1.932h-.906v-2.03c0-.369-.24-.602-.559-.602s-.56.24-.56.601v2.031h-.905v-2.03c0-.369-.24-.602-.559-.602-.318 0-.559.24-.559.601v2.031h-.892zM7.12 11.17c-.213-.807-.665-1.069-1.097-1.069s-.885.262-1.097 1.069L4 14.544h.913c.064-.248.205-.474.403-.63.198-.162.446-.247.708-.247s.502.085.708.247c.198.163.346.382.403.63h.913zm-1.096 1.71a1.13 1.13 0 0 0-.75.29l.523-1.967c.05-.191.128-.248.227-.248s.177.057.226.248l.524 1.967a1.1 1.1 0 0 0-.75-.29"
    />
  </svg>
);
export default SvgAlmaOnCard;
